import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import * as GateSelectors from 'app/modules/gates/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as OrgActions from 'app/modules/org/actions'
import * as InboxActions from 'app/modules/inbox/actions'
import { inboxes } from 'app/modules/inbox/selectors'
import Accordion from 'components/settings/Accordion'
import ClickThroughAccordion from 'components/settings/ClickThroughAccordion'
import BulkMessageActions from './BulkMessageActions'
import ManageInboxes from 'components/settings/inboxes/ManageInboxes'
import ManageTags from 'components/settings/tags/ManageTags'
import Unsubscription from 'components/settings/Unsubscription'
import { ensureIsAdmin } from 'app/modules/access/helpers'
import ACCESS, { Gates } from 'utils/Access'
import { settingsAppConfig } from 'app/modules/user/selectors'


import style from './style.styl'

class ConversationsSettings extends Component {
  static contextTypes = {
    app: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      tagsOpen: false,
      inboxesOpen: false,
      unsubscriptionsOpen: false,
    }
  }

  componentDidMount() {
    this.props.actions.fetchInboxList()
  }

  handleTagsToggle = () => {
    this.setState({ tagsOpen: !this.state.tagsOpen })
  }

  handleUnsubscriptionsToggle = () => {
    this.setState({ unsubscriptionsOpen: !this.state.unsubscriptionsOpen })
  }

  handleInboxesToggle = () => {
    this.setState({ inboxesOpen: !this.state.inboxesOpen })
  }

  handleBulkCloseToggle = () => {
    this.setState({ bulkCloseOpen: !this.state.bulkCloseOpen })
  }

  redirectToSavedReplies = () => {
    this.context.router.push('/settings/replies')
  }

  render() {
    const { tagsOpen, inboxesOpen, unsubscriptionsOpen, bulkCloseOpen } = this.state
    const { hasPremiumDrift, settingsAppConfig: { hasSavedReplies, hasTags, hasBulkClose, hasEmailSendingDomains, hasEmailPreferencesLink, hasInboxes, hasAdvanced } } = this.props

    return (
      <div className={cx(style.Conversations)}>
        {hasSavedReplies && (
          <ClickThroughAccordion
            title="Saved replies"
            description="Manage your saved replies"
            redirectToUrl="/settings/replies"
          />
        )}
        {hasTags && (
          <Accordion
            title="Tags"
            description="Tags organize your inboxes and customer base"
            open={tagsOpen}
            onToggle={this.handleTagsToggle}
          >
            <ManageTags />
          </Accordion>
        )}
        {hasEmailPreferencesLink && (
          <Accordion
            title="Email preferences link"
            description="Copy a link for someone to manage what emails they get from your company"
            open={unsubscriptionsOpen}
            onToggle={this.handleUnsubscriptionsToggle}
          >
            <Unsubscription />
          </Accordion>
        )}
        {hasEmailSendingDomains && (
          <ClickThroughAccordion
            title="Email sending domains"
            description="Manage the domains you use to send emails through Drift"
            redirectToUrl="/settings/dkim"
          />
        )}
        {hasInboxes && (
          <Accordion
            title="Inboxes"
            description={hasPremiumDrift ? `Create multiple inboxes to organize your conversations` : `Configure your inbox`}
            open={inboxesOpen}
            onToggle={this.handleInboxesToggle}
          >
            <ManageInboxes />
          </Accordion>
        )}
        {hasAdvanced && (
          <ClickThroughAccordion
            title="Advanced"
            description="Customize advanced settings"
            redirectToUrl="/settings/conversations/advanced"
          />
        )}
        {hasBulkClose && (
            <Accordion
              title="Bulk close"
              description="Close all of the open conversations in an inbox."
              open={bulkCloseOpen}
              onToggle={this.handleBulkCloseToggle}
            >
              <BulkMessageActions />
            </Accordion>
          )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  hasPremiumDrift: GateSelectors.hasStarterPlan(state),
  orgProperties: OrgSelectors.properties(state),
  hasBetaBulkClose: GateSelectors.hasBetaBulkClose(state),
  inboxes: inboxes(state),
  settingsAppConfig: settingsAppConfig(state),
})

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        fetchInboxList: InboxActions.fetchInboxList,
        patchOrgProperties: OrgActions.patchOrgProperties,
      },
      dispatch
    ),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ensureIsAdmin(ConversationsSettings))



// WEBPACK FOOTER //
// ./src/scripts/components/settings/conversations/index.js